/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/date_parse.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Returns a date by parsing the second argument using the format specified in the first argument.',
  examples: [
    'ROW date_string = "2022-05-06"\n| EVAL date = DATE_PARSE("yyyy-MM-dd", date_string)',
  ],
  params: {
    dateString: 'Date expression as a string. If `null` or an empty string, the function returns `null`.',
    datePattern: 'The date format. Refer to the {javadoc14}/java.base/java/time/format/DateTimeFormatter.html[`DateTimeFormatter` documentation] for the syntax. If `null`, the function returns `null`.',
    options: '(Optional) Additional options for date parsing, specifying time zone and locale as <<esql-function-named-params,function named parameters>>.',
  },
};

export default docs;
